import * as types from 'features/support/feedbackActions';
import { REHYDRATE } from 'redux-persist';

let defaultState = {
    messageStatus: {
        isSending: false,
        sent: false,
        error: null
    },
    feedbackStatus: {
        isSending: false,
        sent: false,
        error: null,
        hasStarRating: false
    }
};

export default function feedback(state = defaultState, action) {
    switch (action.type) {
        case types.SEND_MESSAGE_TO_SUPPORT_START:
            return {
                ...state,
                messageStatus: {
                    isSending: true,
                    sent: false
                }
            };

        case types.SEND_MESSAGE_TO_SUPPORT_COMPLETED:
            return {
                ...state,
                messageStatus: {
                    isSending: false,
                    sent: true
                }
            };

        case types.SEND_MESSAGE_TO_SUPPORT_ERROR:
            return {
                ...state,
                messageStatus: {
                    isSending: false,
                    sent: false,
                    error: action.error
                }
            };

        //--------------------------------------------------------------------

        case types.SEND_FEEDBACK_TO_SUPPORT_START:
            return {
                ...state,
                feedbackStatus: {
                    isSending: true,
                    sent: false,
                    hasStarRating: false
                }
            };

        case types.SEND_FEEDBACK_TO_SUPPORT_COMPLETED:
            return {
                ...state,
                feedbackStatus: {
                    isSending: false,
                    sent: true,
                    hasStarRating: action.payload.starRatingData ? true : false
                }
            };

        case types.SEND_FEEDBACK_TO_SUPPORT_ERROR:
            return {
                ...state,
                feedbackStatus: {
                    isSending: false,
                    sent: false,
                    error: action.error
                }
            };

        case REHYDRATE:
            return {
                ...state
            };

        default:
            return state;
    }
}
